<template>
  <div class="mx-4">
    <v-icon v-if="localValue" @click="toggleZeroSalesPrice">
      mdi-currency-eur-off
    </v-icon>
    <v-icon v-else @click="toggleZeroSalesPrice">
      mdi-currency-eur
    </v-icon>
  </div>
</template>

<script>
import localValue from '@/mixins/localValue';
export default {
  mixins: [localValue],
  methods: {
    toggleZeroSalesPrice() {
      this.localValue = !this.localValue;
    },
  },
};
</script>
<style lang="css" scoped>
</style>
